import { pushToast } from './toasts.js'

interface ProblemJson {
  title?: string
  detail?: string
  status?: number
}

const KNOWN_DETAILS: Record<string, string> = {
  invalid_credentials: 'Wrong email or password.',
  login_failed: 'Sign-in failed. Please check your connection and try again.',
  missing_refresh: 'Your session expired. Please sign in again.',
  invalid_refresh: 'Your session expired. Please sign in again.',
  refresh_expired: 'Your session expired. Please sign in again.',
  token_reuse_detected: 'Your session was invalidated for security. Please sign in again.',
  user_not_found: "That user account doesn't exist anymore.",
  email_already_exists: 'That email is already in use.',
  breed_already_exists: 'A breed with that name already exists.',
  animal_not_found: "That animal doesn't exist.",
  person_not_found: "That person doesn't exist.",
  breed_not_found: "That breed doesn't exist.",
  unit_not_found: "That unit doesn't exist.",
  property_manager_not_found: "That property manager doesn't exist.",
  occupancy_not_found: "That occupancy doesn't exist.",
  lease_not_found: "That lease doesn't exist.",
  animal_referenced_by_other_records: "Can't delete: this animal has occupancies.",
  person_referenced_by_other_records: "Can't delete: this person has occupancies or leases.",
  breed_referenced_by_other_records: "Can't delete: this breed is used by one or more animals.",
  unit_referenced_by_other_records: "Can't delete: this unit has occupancies.",
  property_manager_referenced_by_other_records: "Can't delete: this property manager has units.",
  lease_referenced_by_other_records: "Can't delete: this lease has occupancies.",
  invalid_status_transition: "That action isn't allowed from the current status.",
  intake_rate_limited: 'Too many submissions. Please wait a moment and try again.',
  public_intake_already_exists: 'That email is already in use. Please contact us if you need help.',
}

export function showError(problem: ProblemJson | undefined | null): void {
  const detail = problem?.detail
  const message =
    detail && KNOWN_DETAILS[detail] ? KNOWN_DETAILS[detail] : (detail ?? 'Something went wrong.')
  pushToast('error', message)
}

/**
 * Widens openapi-fetch's `error` (typed per-endpoint, but always a loose JSON body or
 * undefined at runtime) to the ProblemJson shape showError expects, in one place - so call
 * sites don't each need their own `as ApiError` cast.
 */
export function showApiError(error: unknown): void {
  showError((error ?? undefined) as ProblemJson | undefined)
}
